var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 187,
    viewBox: "0 0 185 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.257 19.3294L96.8623 6.23999L77.1109 103.408L141.505 116.498L161.257 19.3294Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.525 13.0894L98.1309 0L78.3794 97.1682L142.774 110.258L162.525 13.0894Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.218 19.4043L101.482 8.27808L87.2163 78.4612L141.952 89.5874L156.218 19.4043Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.843 58.5208L106.008 52.6594L103.574 64.6351L132.409 70.4964L134.843 58.5208Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.515 185.274V136.625L176.164 132.281L184.852 185.274H127.515Z",
    style: {
      fill: "var(--clothes-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.471 111.818L130.549 128.81V136.361L173.108 132.555L170.946 111.818C170.946 111.818 176.163 87.1134 169.647 71.0358C166.743 63.5827 165.456 55.5976 165.871 47.6096C166.196 40.2508 155.63 38.5659 153.691 45.6811C152.889 48.7261 152.331 54.8161 152.392 60.9873C152.413 63.5879 151.866 66.1617 150.788 68.5287C148.2 74.2736 143.856 85.5503 146.464 91.8737L141.45 116.518L118.471 111.818Z",
    style: {
      fill: "var(--skin-color)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M113.101 98.5829C115.87 98.5829 118.115 96.338 118.115 93.5688C118.115 90.7996 115.87 88.5547 113.101 88.5547C110.332 88.5547 108.087 90.7996 108.087 93.5688C108.087 96.338 110.332 98.5829 113.101 98.5829Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M141.491 116.498L145.795 134.991L130.549 136.361V128.809L118.471 111.818L141.491 116.498Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.4971 139.021L74.1357 128.373C74.1357 128.373 82.2557 124.313 91.8068 120.253C101.358 116.193 105.804 109.646 104.525 104.632C103.246 99.6182 93.8064 93.5688 93.8064 93.5688C93.8064 93.5688 112.361 66.7627 113.091 61.373C113.822 55.9834 109.163 53.9534 103.083 57.719C97.0036 61.4847 85.1281 75.6744 85.1281 75.6744C85.1281 75.6744 64.8281 66.1131 57.0431 72.7715C49.258 79.4299 46.7307 100.826 35.6367 119.279L69.4971 139.021Z",
    style: {
      fill: "var(--skin-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5003 117.442L74.4097 135.783L59.0527 186.685L0 185.274L32.5003 117.442Z",
    style: {
      fill: "var(--clothes-color)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.147 48.9641L109.622 43.8144C109.37 43.7636 109.207 43.5183 109.258 43.2666L112.568 26.8572C112.619 26.6055 112.864 26.4425 113.116 26.4933L138.642 31.6431C138.893 31.6939 139.056 31.9392 139.006 32.1909L135.695 48.6003C135.644 48.852 135.399 49.0149 135.147 48.9641Z",
    fill: "#41479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.006 32.1909C139.056 31.9392 138.893 31.6939 138.642 31.6431L136.602 31.2316L127.042 35.0606L128.158 29.528L123.6 28.6084L122.483 34.141L115.155 26.9048L113.116 26.4933C112.864 26.4425 112.619 26.6055 112.568 26.8572L112.33 28.0361L118.618 34.2444L111.373 32.7828L110.453 37.3409L117.698 38.8026L109.495 42.0877L109.258 43.2666C109.207 43.5183 109.37 43.7636 109.622 43.8144L111.661 44.2258L121.221 40.3969L120.105 45.9295L124.663 46.8491L125.78 41.3165L133.108 48.5527L135.147 48.9641C135.399 49.0149 135.644 48.852 135.695 48.6003L135.933 47.4214L129.646 41.213L136.89 42.6747L137.81 38.1165L130.565 36.6549L138.768 33.3698L139.006 32.1909Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.626 39.0281L125.775 36.6372L127.246 29.3441L124.511 28.7923L123.04 36.0854L111.189 33.6945L110.637 36.4293L122.488 38.8203L121.017 46.1134L123.752 46.6651L125.223 39.372L137.074 41.763L137.626 39.0281Z",
    fill: "#FF4B55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.693 39.2053L109.257 43.3333C109.245 43.5599 109.392 43.7683 109.621 43.8146L110.249 43.9412L121.367 39.5432L119.693 39.2054L119.693 39.2053Z",
    fill: "#FF4B55"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M128.339 40.9496L126.665 40.6118L135.196 48.9643C135.43 48.9861 135.648 48.8357 135.695 48.6004L135.771 48.2257L128.339 40.9496Z",
    fill: "#FF4B55"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.467 27.3606L119.726 34.4684L121.401 34.8062L112.917 26.4996C112.746 26.5406 112.605 26.6742 112.568 26.8574L112.467 27.3606Z",
    fill: "#FF4B55"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.545 36.2475L139.006 32.1096C139.01 31.889 138.866 31.6886 138.642 31.6434L137.989 31.5116L126.871 35.9097L128.545 36.2475Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLanguage);
export default __webpack_public_path__ + "static/media/choose-language.b2fa80f8c4b1ab449019f5714e0d5a92.svg";
export { ForwardRef as ReactComponent };